import React, { useEffect, useRef, useState } from 'react'
import "./OnboardingPage.scss"
import OnboardingForm from './OnboardingForm'
import { useAddOnboardDataMutation, useGetOnboardClientsQuery } from '../../services/kmt/crpClient.service'
import editPdf from './PdfEdit'
import { format } from 'date-fns'
import html2canvas from 'html2canvas'
import { Buffer } from 'buffer'


function OnboardingPage() {
  const { data: onboardedClientDetails = null, isLoading } = useGetOnboardClientsQuery()
  const [addOnboardDetails] = useAddOnboardDataMutation()
  const [index, setIndex] = useState(-1)
  const convertRef = useRef(null)

  useEffect(() => {
    (async () => {
      let ndaBuffer, slaBuffer = null
      if (index < 0) return
      if (onboardedClientDetails) {
        const { onboardDetails: { companyInformation: { companyRegisteredName: companyName, billingAddress: companyAddress }, financeContactInformation: { personName: financePersonName, designation: financePersonDesignation = "" }, createdAt },
          cipAccessControl: { onboardingState }, clientCode, onboarding: { onboardingDoc }
        } = onboardedClientDetails.onboardedClientDetails[index]
        if (onboardingState !== "onboarding_without_forms") {
          ndaBuffer = await editPdf("nda", "/NDA.pdf", format(new Date(createdAt), "PPP"), {
            companyName,
            companyAddress,
            financePersonName,
            financePersonDesignation
          })

          slaBuffer = await editPdf("sla_msa", "/sla_2024.pdf", createdAt, {
            companyName,
            companyAddress,
            financePersonName,
            financePersonDesignation
          })
        } else {
        }
        await handleConvertAndSave(ndaBuffer, slaBuffer, clientCode, onboardingDoc, companyName, index)
      }
    })()
  }, [index])

  if (isLoading) return <></>

  function handleIndexChange(change = 1) {
    setIndex(prev => prev + change)

  }
  async function handleConvertAndSave(ndaBuffer, slaBuffer, clientCode, onboardingDoc, companyName) {
    const node = document.getElementById("CompanyInfo")
    const canvas = await html2canvas(node, { useCORS: true })
    let imgData = canvas.toDataURL('image/png');

    const payload = {
      clientCode: clientCode,
      onboardingId: onboardingDoc,
      companyName: companyName,
      formData: {
        data: imgData,
        name: `onboarding_data.png`
      },
      nda: {
        data: ndaBuffer ? `data:pdf;base64,${Buffer.from(ndaBuffer).toString("base64")}` : null,
        name: 'nda.pdf'
      },
      slaMsa: {
        data: slaBuffer ? `data:pdf;base64,${Buffer.from(slaBuffer).toString("base64")}` : null,
        name: 'sla_msa.pdf'
      }
    }
    await addOnboardDetails(payload, index)
    if(onboardedClientDetails.totalDocs - 1 !== index){
      handleIndexChange(1)
    }
  }

  return (
    <div className='OnboardingPage'>
      {index}
      <button disabled={0 === index} onClick={() => handleIndexChange(-1)}>Prev</button>
      <button disabled={onboardedClientDetails.totalDocs - 1 === index} onClick={() => handleIndexChange(1)}>Next</button>
      <button ref={convertRef} onClick={() => handleIndexChange(1)}>Start Conversion</button>
      <div id="CompanyInfo">
        {
          index >= 0 && <OnboardingForm onboardedClientDetails={onboardedClientDetails.onboardedClientDetails[index]} />
        }
      </div>

      {/* <div className="py-12" style={{ padding: "12rem 0rem" }}>
        {
          ndaBuffer && <>
            <PdfView fileLink={ndaBuffer} />
          </>
        }
      </div>
      <div className="py-12" style={{ padding: "12rem 0rem" }}>
        {
          slaBuffer && <>
            <PdfView fileLink={slaBuffer} />
          </>
        }
      </div> */}
    </div>
  )
}

export default OnboardingPage